import Vue from 'vue'
import Router from 'vue-router'
import {routers} from './router.js'
import ElementUI from 'element-ui'
import Cookies from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(Router)
const RouterConfig = {
  mode: 'history',
  routes: routers
}
export const router = new Router(RouterConfig)

router.beforeEach((to, from, next) => {

  next()
   if(to.name !== 'login'){
         if(Cookies.get('tokenEshopManager')){
           next()
         }else{
           next({
             name: 'login'
           })
         }
   }
   // console.log(Cookies.get('tokenEshopManager'))

})



// WEBPACK FOOTER //
// ./src/router/index.js